var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "article",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160.699,
    height: 257.944,
    viewBox: "0 0 160.699 257.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2705",
    "data-name": "Rectangle 2705",
    width: 160.699,
    height: 257.944,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2693",
    "data-name": "Rectangle 2693",
    width: 45.151,
    height: 14.813,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2694",
    "data-name": "Rectangle 2694",
    width: 15.987,
    height: 60.44,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2695",
    "data-name": "Rectangle 2695",
    width: 15.876,
    height: 51.888,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2696",
    "data-name": "Rectangle 2696",
    width: 11.318,
    height: 11.785,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2699",
    "data-name": "Rectangle 2699",
    width: 26.297,
    height: 171.295,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2701",
    "data-name": "Rectangle 2701",
    width: 2.089,
    height: 5.263,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2702",
    "data-name": "Rectangle 2702",
    width: 5.21,
    height: 5.211,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2703",
    "data-name": "Rectangle 2703",
    width: 4.524,
    height: 11.393,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10672",
    "data-name": "Group 10672",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671",
    "data-name": "Group 10671",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670",
    "data-name": "Group 10670",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12878",
    "data-name": "Path 12878",
    d: "M709.426,130.289c-2.736-.518-5.294-5.09-6.183-6.843a2.177,2.177,0,0,1-.2-1.391l1.089-5.772s2.513.427,2.318,3.773a2.466,2.466,0,0,0,.175,1.019l.962,2.517,2.844-2.2-1.56-4.4a7.569,7.569,0,0,1-3.165.229c-2.213-.706.688-2.431,1.605-2.615s2.936-.917,3.853.642,1.468,2.477,1.468,2.477,1.009-3.486.321-11.284c-.031-.351.848-.343,1.1-.092.739.752,1.916,3.041,1.978,10,0,0,.123-8.111,1.514-8.945,1.147-.688,1.726,3.281.918,10.014,0,0,1.5-5.829,2.568-5.839,1.808-.018.024,15.567-4.52,20.212Z",
    transform: "translate(-561.029 -84.723)",
    fill: "#f9b384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12879",
    "data-name": "Path 12879",
    d: "M725.362,213.813q-.121,1.164-.267,2.254v.008a65.491,65.491,0,0,1-1.2,6.875c-.024.1-.04.186-.065.275-1.381,5.663-1.632,8.434-6.35,7.691l-4.855-5.526-.049-.056-.355-.4.985-2.908.129-.38.727-2.116.089-.275,1.244-3.644.5-1.478Z",
    transform: "translate(-568.385 -170.631)",
    fill: "#f9b384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12880",
    "data-name": "Path 12880",
    d: "M271.5,1210.075l-1.236,3.862c-8.474,2.784-13.417,5.973-13.733,9.694h24.5L283,1210.7a19.008,19.008,0,0,1-11.5-.624",
    transform: "translate(-204.724 -965.688)",
    fill: "#1f3c88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12881",
    "data-name": "Path 12881",
    d: "M333.726,1162.533l-3.072,9.6a19.009,19.009,0,0,0,11.5.624l1.267-8.341Z",
    transform: "translate(-263.875 -927.748)",
    fill: "#f9b384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12882",
    "data-name": "Path 12882",
    d: "M508.175,1169.313l.719-9.78-11.512.606-.629,9.015a18.836,18.836,0,0,0,11.422.158",
    transform: "translate(-396.429 -925.353)",
    fill: "#f9b384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12883",
    "data-name": "Path 12883",
    d: "M518.122,1221.315c-.317-3.721-4.645-8.819-14.137-10.031l.291-3.954a18.835,18.835,0,0,1-11.422-.158l-.987,14.143Z",
    transform: "translate(-392.529 -963.371)",
    fill: "#1f3c88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12884",
    "data-name": "Path 12884",
    d: "M452.234,155.44l-13.887.1v-21h13.467l.008,1.284.065,6.657.1,10.688Z",
    transform: "translate(-349.819 -107.363)",
    fill: "#f9b384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12885",
    "data-name": "Path 12885",
    d: "M458.942,152.55c-2.5,2.625-9.007-.339-11.754-3.231l11.689-3.425Z",
    transform: "translate(-356.874 -116.429)",
    fill: "#e28b6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12886",
    "data-name": "Path 12886",
    d: "M434.513,55.246a30.035,30.035,0,0,1-.364,4.726c-.679,4.233-2.472,7.893-6.608,8.006-9.775.283-12.562-5.308-14.4-9.88s1.147-15.592,1.147-15.592l12.651-1.252,6.947,5.7a51.833,51.833,0,0,1,.63,8.3",
    transform: "translate(-329.222 -32.923)",
    fill: "#f9b384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12887",
    "data-name": "Path 12887",
    d: "M389.251,22.558s2.789-.128,3.265-7.327c4.987,1.669,8.631.147,11.518-3.174,2.464,3.254,9.36,4.273,11.689-2.389,1.683-4.813-2.962-11.983-9.728-7.641-6.631-3.35-16.688-3.12-19.582,5.1,0,0-10.061,4.639.592,14.852a12.311,12.311,0,0,0,2.245.581",
    transform: "translate(-304.941 -0.001)",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12888",
    "data-name": "Path 12888",
    d: "M506.251,611.833,498.576,727.9H480.534l4.511-112.627,2.76-1.279Z",
    transform: "translate(-383.485 -488.268)",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12889",
    "data-name": "Path 12889",
    d: "M325.19,499.15,312.534,631.1h19.658l18.715-109.6,21.273-6.463.942-23.427-47.393-1.077Z",
    transform: "translate(-249.414 -391.465)",
    fill: "#1f3c88"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10648",
    "data-name": "Group 10648",
    transform: "translate(74.606 94.621)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10647",
    "data-name": "Group 10647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10646",
    "data-name": "Group 10646",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12890",
    "data-name": "Path 12890",
    d: "M373.4,481.865c10.737,3.854,35.928-.551,41.159-5.919l-3.717-7.434-41.434,5.506Z",
    transform: "translate(-369.407 -468.512)",
    fill: "#102048"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12891",
    "data-name": "Path 12891",
    d: "M439.146,261.1c-.347.145-.7.3-1.066.436a72.922,72.922,0,0,1-13.459,4.007,61.764,61.764,0,0,1-9.024,1.107,52.141,52.141,0,0,1-14.17-1.147l6.018-56.113.735-6.842s7.876,9.694,16.561-1.01Z",
    transform: "translate(-320.355 -160.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10651",
    "data-name": "Group 10651",
    transform: "translate(81.073 45.447)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10650",
    "data-name": "Group 10650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10649",
    "data-name": "Group 10649",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12892",
    "data-name": "Path 12892",
    d: "M415.6,285.4a52.139,52.139,0,0,1-14.17-1.147l6.018-56.113,2.149-3.106c5.307,12.909,10.744,41.495,6,60.366",
    transform: "translate(-401.427 -225.032)",
    fill: "#1f3c88"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12893",
    "data-name": "Path 12893",
    d: "M174.349,195.533c5.984,25.407,8.446,51.551-.37,80.582-6.538,2.487-13.656,2.459-21.273.269l1.885-52.779-44.364,30.5-2.693-16.628c17.054-16.307,46.54-40.941,66.815-41.941",
    transform: "translate(-85.816 -156.043)",
    fill: "#708cd5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10654",
    "data-name": "Group 10654",
    transform: "translate(101.848 52.818)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10653",
    "data-name": "Group 10653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10652",
    "data-name": "Group 10652",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12894",
    "data-name": "Path 12894",
    d: "M520.175,309.414a72.923,72.923,0,0,1-13.459,4.007c-2.674-15.333-3.264-40.521-1.091-51.888Z",
    transform: "translate(-504.299 -261.532)",
    fill: "#1f3c88"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10657",
    "data-name": "Group 10657",
    transform: "translate(144.197 48.618)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10656",
    "data-name": "Group 10656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10655",
    "data-name": "Group 10655",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12895",
    "data-name": "Path 12895",
    d: "M725.3,244.434c-.024.1-.04.186-.065.275-1.381,5.663-1.632,8.434-6.35,7.69l-4.855-5.526-.048-.056.63-3.312.129-.38.727-2.116.089-.275Z",
    transform: "translate(-713.987 -240.733)",
    fill: "#e28b6d"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12896",
    "data-name": "Path 12896",
    d: "M557.778,212.31s-11.916,25.245-18.984,25.851c-6.853.587-10.1-6.059-10.1-6.059L533.543,269a30.933,30.933,0,0,1-19.121,2.69c-6.406-20.8-8.828-47.7-9.3-77.654,5.186.323,15.458.766,19.136,3.13C530.85,201.4,539,216.552,539,216.552l9.492-12.925Z",
    transform: "translate(-403.103 -154.846)",
    fill: "#708cd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12897",
    "data-name": "Path 12897",
    d: "M46.609,62.861s.721-12.077,1.95-11.507,3.694,11.071,3.694,11.071l-2.636,4.253Z",
    transform: "translate(-37.196 -40.968)",
    fill: "#6f3428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12898",
    "data-name": "Path 12898",
    d: "M121.723,1188.2l.357,3.975a12.756,12.756,0,0,1-11.563,13.846l-1.022.092a12.757,12.757,0,0,1-13.846-11.563l-.357-3.975Z",
    transform: "translate(-76.047 -948.232)",
    fill: "#ee6f57"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2697",
    "data-name": "Rectangle 2697",
    width: 26.538,
    height: 193.236,
    transform: "translate(1.954 49.883) rotate(-5.134)",
    fill: "#fbc343"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10660",
    "data-name": "Group 10660",
    transform: "translate(9.25 43.538)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10659",
    "data-name": "Group 10659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10658",
    "data-name": "Group 10658",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2698",
    "data-name": "Rectangle 2698",
    width: 9.425,
    height: 169.377,
    transform: "matrix(0.996, -0.089, 0.089, 0.996, 0.877, 1.72)",
    fill: "none",
    stroke: "#6f3428",
    strokeWidth: 8
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12899",
    "data-name": "Path 12899",
    d: "M111.166,1070.838l-26.424,2.375-.695-7.755-.485-5.388-1.495-16.561,26.433-2.375,1.486,16.561.485,5.388Z",
    transform: "translate(-65.493 -830.866)",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2700",
    "data-name": "Rectangle 2700",
    width: 26.531,
    height: 5.41,
    transform: "matrix(0.996, -0.09, 0.09, 0.996, 18.069, 229.203)",
    fill: "#fbc343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12900",
    "data-name": "Path 12900",
    d: "M9.658,127.672,17,98.248a6.311,6.311,0,0,0,5.608-.774L36.091,125.3Z",
    transform: "translate(-7.707 -77.788)",
    fill: "#ee6f57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12901",
    "data-name": "Path 12901",
    d: "M399.545,100.431c-.118-.434-2.091-1.031-2.526-1.151a3.029,3.029,0,0,0-2.06.019c-2.385,1.078-2.067,4.494-.831,6.289a5.38,5.38,0,0,0,2.917,2.141c.433.124,4.537.173,4.357-.487l-1.858-6.812",
    transform: "translate(-313.773 -79.092)",
    fill: "#f9b384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12902",
    "data-name": "Path 12902",
    d: "M10.678,435.388a3.592,3.592,0,0,0-4.59-2.371c-3.007,1.038-5.626,2.8-6.031,5.8-.369,2.728,1,11.444,7.091,12.564l-.5-4.478s3.732-.871,4.478-2.488c.522-1.132.557-5.86-.45-9.022",
    transform: "translate(0 -345.408)",
    fill: "#f9b384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12903",
    "data-name": "Path 12903",
    d: "M611.4,297.109c.32,1.907.593,3.82.855,5.735s.486,3.833.732,5.749l.626,5.761c.183,1.923.361,3.847.479,5.779l-.314.037c-.33-1.906-.6-3.82-.867-5.733l-.72-5.75c-.2-1.921-.437-3.839-.615-5.763s-.363-3.847-.491-5.777Z",
    transform: "translate(-487.675 -237.105)",
    fill: "#1f3c88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12904",
    "data-name": "Path 12904",
    d: "M337.612,295.511c0,2.142-.057,4.282-.12,6.421s-.164,4.276-.244,6.415l-.35,6.41c-.143,2.135-.29,4.271-.5,6.4l-.315-.015c-.006-2.142.049-4.282.108-6.421l.256-6.414c.122-2.137.214-4.274.362-6.41s.288-4.271.486-6.4Z",
    transform: "translate(-268.208 -235.818)",
    fill: "#1f3c88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12905",
    "data-name": "Path 12905",
    d: "M465.077,100.032a1.27,1.27,0,0,1-.7,1.606c-.558.125-1.149-.391-1.319-1.153a1.27,1.27,0,0,1,.7-1.606c.558-.125,1.149.391,1.319,1.153",
    transform: "translate(-369.501 -78.895)",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12906",
    "data-name": "Path 12906",
    d: "M504.933,94.243c-.033.78-.523,1.393-1.094,1.369s-1.007-.676-.974-1.456.523-1.393,1.094-1.368,1.007.676.974,1.456",
    transform: "translate(-401.305 -74.048)",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12907",
    "data-name": "Path 12907",
    d: "M489.663,103.168a18.329,18.329,0,0,1,.412,1.935,1.515,1.515,0,0,0,.391.672,2.554,2.554,0,0,0,.758.373,2.11,2.11,0,0,1,.957.721,1.254,1.254,0,0,1,.1,1.322,2.49,2.49,0,0,1-.789.8c-.277.187-.544.386-.832.56l-.208-.238c.212-.262.445-.5.668-.748a2.359,2.359,0,0,0,.521-.68c.171-.374-.195-.783-.725-.994a2.815,2.815,0,0,1-.985-.559,1.97,1.97,0,0,1-.518-1.068c-.133-.748.019-1.389-.053-2.011Z",
    transform: "translate(-390.524 -82.332)",
    fill: "#e28b6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12908",
    "data-name": "Path 12908",
    d: "M454.159,87.375a2.352,2.352,0,0,1,.825-1.259,2.51,2.51,0,0,1,1.464-.548A2.71,2.71,0,0,1,459,87l-.247.2a3.469,3.469,0,0,0-2.261-.824,2.64,2.64,0,0,0-2.042,1.138Z",
    transform: "translate(-362.437 -68.283)",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12909",
    "data-name": "Path 12909",
    d: "M495.444,83.255a2.431,2.431,0,0,1,.634-1.021,2.113,2.113,0,0,1,1.147-.568,2.011,2.011,0,0,1,2.142,1.069l-.253.189a2.561,2.561,0,0,0-1.771-.463,2.272,2.272,0,0,0-.844.309,5.587,5.587,0,0,0-.784.645Z",
    transform: "translate(-395.384 -65.152)",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12910",
    "data-name": "Path 12910",
    d: "M473.317,141.907c1.41,2.208,3.29,2.448,4.741.124Z",
    transform: "translate(-377.726 -113.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10663",
    "data-name": "Group 10663",
    transform: "translate(103.24 21.785)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10662",
    "data-name": "Group 10662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10661",
    "data-name": "Group 10661",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12911",
    "data-name": "Path 12911",
    d: "M513.277,107.867a37.25,37.25,0,0,1-.4,5.264,2.433,2.433,0,0,1-1.688-2.318c0-1.22.934-2.76,2.09-2.946",
    transform: "translate(-511.187 -107.868)",
    fill: "#fc8879"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10666",
    "data-name": "Group 10666",
    transform: "translate(89.543 23.569)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10665",
    "data-name": "Group 10665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10664",
    "data-name": "Group 10664",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12912",
    "data-name": "Path 12912",
    d: "M448.577,119.306a2.605,2.605,0,1,1-2.605-2.605,2.605,2.605,0,0,1,2.605,2.605",
    transform: "translate(-443.367 -116.701)",
    fill: "#fc8879"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12913",
    "data-name": "Path 12913",
    d: "M404.247,111.074a13.044,13.044,0,0,0-1.457-.959,1.272,1.272,0,0,0-.642-.167,1.44,1.44,0,0,0-.672.308l-.265-.172a1.256,1.256,0,0,1,.767-.825,1.5,1.5,0,0,1,1.169.135,3.025,3.025,0,0,1,1.351,1.488Z",
    transform: "translate(-320.182 -87.14)",
    fill: "#e28b6d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10669",
    "data-name": "Group 10669",
    transform: "translate(6.604 99.002)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10668",
    "data-name": "Group 10668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10667",
    "data-name": "Group 10667",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12914",
    "data-name": "Path 12914",
    d: "M37.222,490.207,33.472,501.6l-.774-8.9a7.769,7.769,0,0,0,4.524-2.489",
    transform: "translate(-32.698 -490.207)",
    fill: "#6f3428"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.a4e34fffc93c2b8ccce00dfd9e686ce3.svg";
export { ForwardRef as ReactComponent };